export const FORECAST_ACTION_CARD_KIND = {
  INCOME_BUFFER: 'income_buffer',
  LEAN_BURN_AUDIT: 'lean_burn_audit',
  SCHEDULE_CONSULTATION: 'schedule_consultation',
};

export const FORECAST_ACTION_CARD_ORDER = [
  FORECAST_ACTION_CARD_KIND.INCOME_BUFFER,
  FORECAST_ACTION_CARD_KIND.LEAN_BURN_AUDIT,
  FORECAST_ACTION_CARD_KIND.SCHEDULE_CONSULTATION,
];

export const CALENDLY_FINANCE_SYNC_URL =
  'https://calendly.com/mark-casitafinancialplanning/richuel-finance-sync';

export const ENABLE_SCHEDULE_CFP_SESSION_PAGE = true;

const SCHEDULE_CFP_SESSION_ROUTE = '/dashboard/schedule-cfp-session';

export function openCfpScheduling(navigate, calendarUrl = CALENDLY_FINANCE_SYNC_URL) {
  const url = calendarUrl?.trim() || CALENDLY_FINANCE_SYNC_URL;
  if (ENABLE_SCHEDULE_CFP_SESSION_PAGE) {
    navigate(SCHEDULE_CFP_SESSION_ROUTE, { state: { calendarUrl: url } });
  } else {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

export const ACTION_CARD_DESCRIPTION_PLACEHOLDER_KEYS = [
  'monthlyGapPhrase',
  'plannedTransitionPhrase',
  'liquidityPhrase',
  'cashCushionPhrase',
  'totalShortfallPhrase',
  'longevitySuccessScorePhrase',
  'lifetimeWealthIncreasePhrase',
];

export function actionCardDescPlaceholderKeyToSnake(camelKey) {
  return camelKey.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '');
}
